import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import SettingsMenu from "./SettingsMenu";
import SettingsPage from "../../pages/settings/[[...params]]";
import constants from "../../utils/constants";
import { useEffect, useState } from "react";
import { getIsOnpremise } from "../../utils";

const SettingsModal = () => {
  const [selectedPage, setSelectedPage] = useState(constants.SETTINGS.NOTIFICATIONS);
  const { isVisible, hasUnsavedSetting, selectedSetting } = useStoreState(Store, (s) => ({
    isVisible: s.isSettingsOpen,
    hasUnsavedSetting: s.hasUnsavedSetting,
    selectedSetting: s.selectedSetting,
  }));
  const isOnpremise = getIsOnpremise();

  useEffect(() => {
    if (isOnpremise) {
      setSelectedPage(constants.SETTINGS.REMOTE_ACCESS);
    }
  }, [isOnpremise]);

  useEffect(() => {
    if (selectedSetting) {
      setSelectedPage(selectedSetting);
    }
  }, [selectedSetting]);

  const onCloseModal = () => {
    Store.update((s) => {
      s.isSettingsOpen = false;
    });
  };

  const onLogout = () => {
    Store.update((s) => {
      s.isLogoutOpen = true;
    });
  };

  const onChangeSetting = (pageName: string) => {
    if (hasUnsavedSetting) {
      Store.update((s) => {
        s.showUnsavedWarning = true;
      });
    } else {
      Store.update((s) => {
        s.selectedSetting = pageName;
      });
    }
  };

  return (
    <Modal
      show={isVisible}
      className="flex w-full !bg-gray-900 border-0 sm:w-10/12 md:w-full lg:w-8/12 h-4/5 overflow-hidden"
    >
      <SettingsMenu
        onLogout={onLogout}
        onClose={onCloseModal}
        onChange={onChangeSetting}
        selected={selectedPage}
      />
      <SettingsPage pageName={selectedPage} onChangeSetting={onChangeSetting} />
    </Modal>
  );
};

export default SettingsModal;
